import styled from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

export const StyledMetricWrapper = styled(Stack)`
    border-radius: 1%;
    margin-bottom: 24px;
`;
